import { Translation } from 'primeng/api';

/**
 * Textos en inglés de los componentes PrimeNG envueltos por la librería de componentes. Mantiene las mismas claves que
 * `TRADUCCION_PRIMENG_ES` para que al cambiar de idioma se reemplacen todas. `IdiomaServicio` aplica una u otra.
 */
export const TRADUCCION_PRIMENG_EN: Translation = {
  accept: 'Yes',
  reject: 'No',
  choose: 'Choose',
  clear: 'Clear',
  today: 'Today',
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  chooseDate: 'Choose date',
  chooseMonth: 'Choose month',
  chooseYear: 'Choose year',
  prevDecade: 'Previous decade',
  nextDecade: 'Next decade',
  prevYear: 'Previous year',
  nextYear: 'Next year',
  prevMonth: 'Previous month',
  nextMonth: 'Next month',
  prevHour: 'Previous hour',
  nextHour: 'Next hour',
  prevMinute: 'Previous minute',
  nextMinute: 'Next minute',
  prevSecond: 'Previous second',
  nextSecond: 'Next second',
  am: 'AM',
  pm: 'PM',
  dateFormat: 'mm/dd/yy',
  firstDayOfWeek: 0,
  weekHeader: 'Wk',
};
